<template>

 <div class="Auftrag">
  <div class="d-none d-sm-block">
 <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><router-link to="/">Übersicht</router-link>
    </li>
    <li class="breadcrumb-item"><router-link to="/anfragen">Anfragen</router-link>
    </li>
    <li class="breadcrumb-item active" aria-current="page">Auftrag bearbeiten</li>
  </ol>
</nav>
</div>
<b-form ref="form" @reset="onReset" @submit="onSubmit">
 <b-alert :show="errorMessage!=null" variant="danger">{{ errorMessage }}</b-alert>
  <b-card
    header-tag="strong"
    :header-class="headerClass()"
    >
     <b-card-title title-tag="div">
     <strong v-if="!editMode && hasRoles(['Admin','Disponent','Mitglied'])">{{auftrag.firma ? auftrag.firma.name : auftrag.firmaFormular}}</strong>
     <span>&nbsp;</span>
    <span class="text-muted float-right">{{auftrag.firstInvite|formatDate}}</span>
     </b-card-title>
     <template #header>
        {{auftrag.format.name}} <span :class="iconClass()"></span>
     <!-- test umschalter -->
     <b-form-radio-group v-if="showFunctions()" class="float-right" v-model="editMode" buttons size="sm" button-variant="light">
       <b-form-radio class="mr-1" :value="true"><i class="bi bi-person"></i></b-form-radio>
       <b-form-radio class="mr-2" :value="false"><i class="bi bi-people"></i></b-form-radio>
     </b-form-radio-group>
     </template>
    <b-card-text>

    <AuftragCutter v-if="!editMode" :headerClass="headerClass()" :auftrag="auftrag" :aaMessage="aaMessage" :editMode="editMode"
    :user="user"/>
    <AuftragDisponent v-if="editMode"
    @select-all-cutters="selectAllCutters()" @deselect-all-cutters="deselectAllCutters()" @toggle-all-cutters="toggleAllCutters()"
    @select-all-mitglied="selectMitglieder()" :auftrag="auftrag" :selectedCutters="selectedCutters" :editMode="editMode" @refresh-view="refresh"
    :user="user" :disponenten="disponenten.items" :cutters="cutters.items" :kunden="kunden.items"
    :einzuladendeCutter="einzuladendeCutter"/>

<div v-if="!editMode">
    <div class="mb-2">
      <b-form-group
        v-if="auftrag.__myAngebot && !auftrag.cutterId && auftrag.__myAngebot.auftragAngebotStatus=='NeueAnfrage'"
        label-cols="12" id="input-group-info-message" label="Nachricht:"
        label-for="input-info-message"> <b-form-textarea ref="aaMessage"
        @keydown="myPrevent($event, 'aaMessage')"
        rows="2" id="input-info-message" v-model="aaMessage"
        placeholder="Nachricht an Disposition..."></b-form-textarea> </b-form-group>
    </div>
    <div v-if="headerClass().includes('status-zugeteilt-anderer')">
    <strong>Der Job wurde bereits vergeben</strong>
    </div>
    <div v-if="headerClass().includes('status-AnfrageAbgelehnt')">
    <strong>Wir konnten niemanden für den Job finden.</strong>
    </div>
    <div v-if="headerClass().includes('status-Storniert')">
    <strong>Der Kunde hat die Anfrage storniert.</strong>
    </div>
</div>
  <b-button pill v-if="isAllowedToEdit()" type="button" name="Update" @click="action($event, {name:'Update',type:'Manual'},auftrag.id)" class="m-2" size="sm" variant="secondary">
    Speichern
    </b-button>
    <span v-for="(btn, idx) in auftrag.__actions" :key="idx">
        <b-button pill type="button" :name="btn.name" @click="action($event, btn,auftrag.id)" class="m-2" size="sm" :variant="btn.variant" data-toggle="tooltip" data-placement="top" :title="btn.description">
          {{btn|actionText}}
         </b-button>
    </span>
    <b-button v-if="isAllowedToEdit()" pill size="sm" variant="primary" :href="csvLink(auftrag.id)">CSV Downloaden</b-button>
    </b-card-text>
    </b-card>
    <!-- needed by upload -->
    <input id="file-input" ref="fileInput" @change="uploadFile(auftrag.id)" type="file" name="name" style="display: none;" />
    <input type="hidden" ref="actionName" />
    </b-form>
    <!-- fastreplay modal, kann ausserhalb von form sein  -->
    <FastReply :show="showFastReply" :auftrag="auftrag" @close-event="showFastReply=false"/>

</div>

</template>

<script>
import api from '@/api/workflow'
import userapi from '@/api/benutzer'
import utils from '@/utilities'
import FastReply from '@/components/partials/FastReply'
import AuftragDisponent from '@/components/partials/AuftragDisponent'
import AuftragCutter from '@/components/partials/AuftragCutter'
import afunc from '@/functions'
import Role from '@/models/Role'

const preset = { formatId: null, skillId: null }

export default {
  name: 'Auftrag',
  components: {AuftragDisponent, AuftragCutter, FastReply},
  async mounted () {
    this.refresh()
  },
  computed: {
    labelClass: function () {
      return this.editMode ? '' : 'd-none'
    },
    sendungThema: function () {
      return (this.auftrag.sendung || 'n.v.') + ' - ' + (this.auftrag.thema || 'n.v.')
    }
  },
  methods: {
    myPrevent (event, field) {
      if (event.key === 'Enter') {
        if (this.$refs[field]) {
          afunc.insertAtCaret(event.target, '\n')
        }
        event.preventDefault()
        event.stopPropagation()
      }
    },
    hasRoles (role) {
      return utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), role)
    },
    selectMitglieder () {
      let selection = []
      for (let i = 0; i < this.cutters.items.length; i++) {
        if (utils.hasRole(this.cutters.items[i], Role.Mitglied) && (this.cutters.items[i].standortId === this.selectedStandortId || this.selectedStandortId === 0)) {
          selection[this.cutters.items[i].id] = true
        }
      }
      this.selectedCutters = selection
    },
    selectAllCutters () {
      let selection = []
      for (let i = 0; i < this.cutters.items.length; i++) {
        if (this.cutters.items[i].standortId === this.selectedStandortId || this.selectedStandortId === 0) {
          selection[this.cutters.items[i].id] = true
        } else {
          selection[this.cutters.items[i].id] = false
        }
      }
      this.selectedCutters = selection
    },
    deselectAllCutters () {
      let selection = []
      for (let i = 0; i < this.cutters.items.length; i++) {
        selection[this.cutters.items[i].id] = false
      }
      this.selectedCutters = selection
    },
    toggleAllCutters () {
      let tmp = []
      for (let i in this.selectedCutters) {
        tmp[i] = !this.selectedCutters[i]
      }
      this.selectedCutters = tmp
    },
    showFunctions () {
      return afunc.showInternalFunctions(this.user)
    },
    iconClass () {
      const auftrag = { ...this.auftrag }
      auftrag.disponentId = this.orgDisponent
      return utils.headerClass(this.user, auftrag, 'icon-status') + ' ' + afunc.findIconClass(this.user, auftrag)
    },
    translate (key) {
      if (key === 'AuftragRechnung') {
        return 'Rechnung an Editor*in / Firma'
      }
      if (key === 'CutterRechnung') {
        return 'Rechnung von Editor*in'
      }
      return key
    },
    findStandortId (standort) {
      for (let i = 0; i < this.$store.state.auth.baseData.standorte.length; i++) {
        if (this.$store.state.auth.baseData.standorte[i].name === standort) {
          return this.$store.state.auth.baseData.standorte[i].id
        }
      }
      return 0
    },
    uploadFile (id) {
      afunc.uploadFile(this, api, id)
    },
    fileLink (id, key) {
      return '/api/ws/getfile/' + id + '/' + key + '/' + this.$store.state.auth.token
    },
    csvLink (id) {
      return '/api/ws/getcsv/' + id + '/' + this.$store.state.auth.token
    },
    headerClass () {
      return utils.headerClass(this.user, this.auftrag, 'status')
    },
    isAllowedToEdit () {
      return (utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), ['Admin', 'Disponent']))
    },
    cutterName (cutterId) {
      for (let i = 0; i < this.cutters.length; i++) {
        if (this.cutters[i].id === cutterId) {
          return this.cutters[i].name
        }
      }
      return 'Editor #' + cutterId + ' (Name nicht verfügbar)'
    },
    async action (event, action, id) {
      event.preventDefault()
      if (this.$refs.form.checkValidity()) {
        // if manual or formInput check that the form is valid, otherwise dont submit
        if ((action.type === 'Manual' || action.type === 'FormInput') && (!this.$refs.form.checkValidity())) {
          return
        }
        let selectedCutters = []
        for (let i in this.selectedCutters) {
          if (this.selectedCutters[i]) {
            selectedCutters.push(i)
          }
        }
        var formData = new FormData()
        formData.append('message', this.aaMessage)
        formData.append('selectedCutters', selectedCutters)
        const fields = ['firmaId', 'firmaFormular', 'name', 'telefon', 'datum', 'email', 'sendung',
          'formatId', 'skillId', 'thema', 'tageFormular', 'gageFormular', 'kundeFormular', 'technikMiete', 'standortFormular',
          'information', 'disponentId', 'abrechnungsArt', 'informationDispo', 'editorbewertung', 'schnittplatzId',
          'firmaStrasse', 'firmaPlz', 'firmaOrt', 'vermittlungsArt', 'vermittlungsProvision', 'informationDisponentKunde']
        for (let i = 0; i < fields.length; i++) {
          formData.append(fields[i], this.auftrag[fields[i]])
        }
        let result = await afunc.actionFunc(this, api, action, id, formData)
        if (result && result['fastReply']) {
          return
        }
        if (result && result['redirect']) {
          this.$router.push({path: result['redirect']})
        }

        if (result && result['errorMessage']) {
          this.errorMessage = result['errorMessage']
        } else {
          this.refresh()
          if (result && !result['noMessage']) {
            utils.makeToast(this, 'Erfolgreich ausgeführt!', 'success')
            if (action.name === 'DeleteAuftrag') {
              // to clear to route of any query params, use object
              this.$router.push({ path: '/anfragen' })
            }
          }
        }
      } else {
        this.$refs.form.reportValidity()
      }
    },
    mkTitel (data, mark) {
      return utils.mkTitel(data, mark)
    },
    istEingeladen (cutterId) {
      for (let i = 0; i < this.auftrag.angebote.length; i++) {
        if (this.auftrag.angebote[i].cutterId === cutterId) {
          return true
        }
      }
      return false
    },
    async refresh () {
      this.loading = true
      this.auftrag = await api.get(this.$route.params.auftragId)
      // merken damit wir nicht das falsche icon zeigen
      this.orgDisponent = this.auftrag.disponentId
      if (!this.auftrag.disponentId) {
        // disponent vorbelegen
        this.auftrag.disponentId = this.user.id
      }
      if (!this.auftrag.abrechnungsArt) {
        this.auftrag.abrechnungsArt = 0
      }
      if (utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), ['Disponent', 'Admin'])) {
        this.kunden = await userapi.search(0, -1, {'role': 'Kunde', 'enabled': true})
        this.disponenten = await userapi.search(0, -1, {'role': 'Disponent', 'enabled': true})
        this.cutters = await userapi.search(0, -1, {'role': 'Cutter', 'enabled': true})
        this.selectedCutters = []
        this.einzuladendeCutter = []
        const standortId = this.findStandortId(this.auftrag.standortFormular)
        for (let i = 0; i < this.cutters.items.length; i++) {
          if (!this.istEingeladen(this.cutters.items[i].id)) {
            this.einzuladendeCutter.push(this.cutters.items[i])
            // auswahl nur wenn noch niemand eingeladen ist, weil magnus gerne mal einladen drückt statt speichern
            if (!this.auftrag.angebote.length) {
              this.selectedCutters[this.cutters.items[i].id] = utils.hasRole(this.cutters.items[i], 'Mitglied') && (this.cutters.items[i].standortId === standortId || standortId === 0)
            }
          }
        }
      }
      this.loading = false
    },
    onSubmit (e) {
      e.preventDefault()
      e.stopPropagation()
      return false
    },
    onReset (event) {
      event.preventDefault()
      // Reset our form values
      this.form = preset
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    }
  },
  created () {
    this.$on('standort-selection-changed', (id) => {
      this.selectedStandortId = id
    })
  },
  data () {
    return {
      editMode: utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), ['Admin', 'Disponent']),
      user: this.$store.state.auth.user,
      cutters: [],
      einzuladendeCutter: [],
      disponenten: [],
      orgDisponent: null,
      kunden: [],
      aaMessage: '',
      fieldError: {},
      selectedStandortId: 0,
      selectedCutters: [],
      auftrag: {'format': {}, 'skill': {}},
      errorMessage: null,
      showFastReply: false,
      message: null
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/main/vue/components/Auftrag.vue